import { Config } from '@ms/yammer-data/dist/state/types';

import { getTelemetryClientId } from './getTelemetryClientId';

type GetConfig = () => Promise<Config>;
export const getConfig: GetConfig = async () => {
  const config = window.__yammerconfig__ as Config;
  const telemetryClientId = await getTelemetryClientId();

  return {
    ...config,
    telemetry: {
      ...config.telemetry,
      telemetryClientId,
    },
  };
};
